import util from '../util/util';
export default {
    // 品质流量
    flow: {
        // 轮播图数据
        section1: {
                // 图片地址
                link: util.get_img('flow_banner.png'),
                // 标题
                title: '海量媒体 万里挑一',
                // 描述
                description: '以网易独家资源和有道媒体矩阵为核心，通过UPB流量价值模型甄选海内外品质流量，同时对接多家移动广告平台，覆盖上万家跨屏媒体，涵盖多层次的高价值用户人群',
                // cta文案
                cta: '我要投放'
        },
        // 头部独家资源
        section2: {
            // 模块名称
            name: '头部独家资源',
            // 模块描述
            desc: '网易独家资源和有道媒体矩阵构建核心流量池',
            data: [
                {
                    // 图片地址
                    link: util.get_img('logo_case_youdao@2x.png'),
                    // 标题
                    title: '网易有道词典',
                    // 描述
                    description: '7亿用户精选的教育APP | 教育行业垂直资源'
                },
                {
                    // 图片地址
                    link: util.get_img('logo_case_wangyimail@2x.png'),
                    // 标题
                    title: '网易邮箱大师',
                    // 描述
                    description: '2.8亿用户精选App | 活跃用户超千万'
                },
                {
                    // 图片地址
                    link: util.get_img('logo_case_youdaonote@2x.png'),
                    // 标题
                    title: '有道云笔记',
                    // 描述
                    description: '千万职场人士都在使用的办公协助类App'
                },
                {
                    // 图片地址
                    link: 'https://shared.ydstatic.com/ead/web-youxuan-platform/static/assets/img/home/mooc.png',
                    // 标题
                    title: '中国大学MOOC',
                    // 描述
                    description: '好的大学，没有围墙 | 网易和高等教育出版社出品'
                },
                {
                    // 图片地址
                    link: util.get_img('logo_case_youdaofanyi@2x.png'),
                    // 标题
                    title: '有道翻译官',
                    // 描述
                    description: '百万用户的翻译App | 学生、旅游者必备工具'
                },
                {
                    // 图片地址
                    link: util.get_img('logo_case_yixin@2x.png'),
                    // 标题
                    title: '易信',
                    // 描述
                    description: '2亿用户的社交选择 | 活跃用户超千万'
                }
            ]
        },
        // 全网甄选流量数据
        section3: {
            // 模块名称
            name: '全网甄选流量',
            // 模块描述
            desc: '甄选海内外品质流量，同时对接多家移动广告平台，覆盖上万家跨屏媒体，涵盖多层次的高价值用户人群',
            data: [
                {
                    // icon图片地址
                    link: util.get_img('ic_choose_1.png'),
                    // 数量
                    num: '1000',
                    // 标签
                    tag: '头部App'
                },
                {
                    // icon图片地址
                    link: util.get_img('ic_choose_2.png'),
                    // 数量
                    num: '100',
                    // 标签
                    tag: '品类覆盖'
                },
                {
                    // icon图片地址
                    link: util.get_img('ic_choose_3.png'),
                    // 数量
                    num: '10亿',
                    // 标签
                    tag: '优质用户'
                },
                {
                    // icon图片地址
                    link: util.get_img('ic_choose_4.png'),
                    // 数量
                    num: '100亿',
                    // 标签
                    tag: '日均展示'
                },
                {
                    // icon图片地址
                    link: util.get_img('ic_choose_5.png'),
                    // 数量
                    num: '5亿',
                    // 标签
                    tag: 'DAU'
                }
            ]
        },
        // 展示块数据
        section4: {
            // 模块名称
            name: '展示',
            data: [
                {
                    // 图片地址
                    link: util.get_img('model_upb.png'),
                    // 标题
                    title: 'UPB流量价值模型',
                    title_en: 'FLOW VALUE MODEL',
                    // 描述
                    description: '有道智选对媒体流量一向从严筛选。平台通过用户匹配度、人群购买力以及媒体品牌性构建流量价值模型，从海量媒体中甄选出最优质的流量。',
                    // 图像位置（居左/居右）
                    pos: 'right'
                },
                {
                    // 图片地址
                    link: util.get_img('model_anticheating.png'),
                    // 标题
                    title: '悬镜反作弊系统',
                    title_en: 'AGAINST-CHEATING',
                    // 描述
                    description: '30多项指标构建科学严谨的作弊判定条件，智能机器24小时监控排查，配备专业质控人员不断升级完善系统，让作弊点击无所遁形！若判定点击无效，完全过滤。',
                    // 图像位置（居左/居右）
                    pos: 'left'
                }
            ]
        }
    },

    // AI赋能
    ai: {
        // 轮播图数据
        section1: {
            // 图片地址
            link: util.get_img('ai_banner.png'),
            // 标题
            title: 'AI赋能 智慧决策',
            // 描述
            description: '传承网易有道多年技术经验和云端产品的智能基因，建立行业领先的AI Lab和算法科研团队，将一流的算法融入智能广告系统',
            cta: '我要投放'
        },
        // 展示块数据
        section2: {
            // 模块名称
            name: '展示',
            data: [
                {
                    // 图片地址
                    link: util.get_img('model_kunpeng.png?1'),
                    // 标题
                    title: '鲲鹏数据云',
                    title_en: 'BIG DATA CLOUD',
                    // 描述
                    description: '背靠网易10亿用户人群，有效提炼1000多个特征标签与场景标签，360°全景勾勒用户画像。将最真实可靠的用户行为认知，通过人群定向技术投入到实际的营销决策当中。',
                    // 图像位置（居左/居右）
                    pos: 'right'
                },
                {
                    // 图片地址
                    link: util.get_img('model_robot.png?1'),
                    // 标题
                    title: '智能投放机器人',
                    title_en: 'ADVERTISING ROBOT',
                    // 描述
                    description: '基于EAM技术的智能投放机器人，把影响投放效果的推广因子进行智能排列组合实验，广告主只需输入投放预算以及考核KPI，系统将根据算法自动为您匹配最佳组合，实现预算内的KPI达标。',
                    // 图像位置（居左/居右）
                    pos: 'left'
                },
                {
                    // 图片地址
                    link: util.get_img('model_engin.png?1'),
                    // 标题
                    title: '北辰效果优化引擎',
                    title_en: 'OPTIMIZATION ENGINE',
                    // 描述
                    description: '北辰效果优化引擎包含了自动数据采集、点击率预测模型、OCPC转化率优化模型等重要部分，注重从展示到点击的CTR精准性优化外，触及从点击到转化的CVR有效性优化。',
                    // 图像位置（居左/居右）
                    pos: 'right'
                }
            ]
        }
    },

    // 内容场景
    content: {
        // 轮播图数据
        section1: {
            // 图片地址
            link: util.get_img('content_banner.png'),
            // 标题
            title: '基于场景 用户导向',
            // 描述
            description: '真实还原用户使用场景，为媒体量身定制内容广告形式。以信息流广告为核心，搭配激励视频与互动广告双引擎制动，致力构建多频道内容分发生态',
            cta: '我要投放'
        },
        // 展示块数据
        section2: {
            // 模块名称
            name: '展示',
            data: [
                {
                    // 图片地址
                    link: util.get_img('model_contextual.png'),
                    // 标题
                    title: '智选内容广告',
                    title_en: 'CONTEXTUAL  AD',
                    // 描述
                    description: '有道智选致力于追求极致的用户体验，探索最佳的推广效果，做真正的内容广告；以信息流为核心，为用户解决问题，搭建感性场景，建立双向信任，传递使用价值。',
                    // 图像位置（居左/居右）
                    pos: 'right'
                }
            ]
        },
        section3: {
            // 图片地址
            link: util.get_img('pic_UPB.png'),
            // 标题
            title: '丰富的内容广告形式',
            title_en: 'VARIOUS FORMS',
            // 描述
            description: '真实还原用户使用场景，为媒体量身定制丰富的移动内容广告形式。以信息流广告位核心，搭配激励视频与互动广告双引擎制动，致力于构建多媒体内容分发生态。',
            // 图像位置（居左/居右）
            pos: 'left',
            // 广告数据
            data: [
                {
                    key: '信息流广告',
                    val: util.get_img('pic_FlowAD.png'),
                    active: true
                },
                {
                    key: '互动广告',
                    val: util.get_img('pic_InteractiveAD.png'),
                },
                {
                    key: '开屏广告',
                    val: util.get_img('pic_SplashAD.png'),
                },
                {
                    key: 'banner广告',
                    val: util.get_img('pic_BannerAD.png'),
                },
                {
                    key: '激励视频广告',
                    val: util.get_img('pic_VideoAD.png'),
                }
            ]   
        }
    },

    // 多维服务
    dimension: {
        // 轮播图数据
        section1: {
            // 图片地址
            link: util.get_img('dimension_banner.png'),
            // 标题
            title: '专业服务 极致体验',
            // 描述
            description: '专家推广顾问服务，搭配业内顶尖的创意素材设计师与专业数据分析师团队，围绕您的KPI定制数字营销策略，实现“三位一体”的全方位推广服务',
            cta: '我要投放'
        },
        // 展示块数据
        section2: {
            // 模块名称
            name: '展示',
            data: [
                {
                    // 图片地址
                    link: util.get_img('model_promoter.png'),
                    // 标题
                    title: '专家级推广顾问',
                    title_en: 'SPECIFIC PROMOTER',
                    // 描述
                    description: '深挖用户需求，构建清晰的推广逻辑；具备垂直行业资深的广告优化经验；为您提供品效合一的整合营销方案。',
                    // 图像位置（居左/居右）
                    pos: 'right'
                },
                {
                    // 图片地址
                    link: util.get_img('model_designer.png'),
                    // 标题
                    title: '创意素材设计师',
                    title_en: 'MATERIAL DESIGNER',
                    // 描述
                    description: '提供行业内领先的素材设计服务；整合优质素材特征，提炼创意模板；支持平面、视频、互动等多种广告素材样式的设计。',
                    // 图像位置（居左/居右）
                    pos: 'left'
                },
                {
                    // 图片地址
                    link: util.get_img('model_analyst.png'),
                    // 标题
                    title: '数据分析师',
                    title_en: 'DATA ANALYST',
                    // 描述
                    description: '定时反馈广告投放数据报表，搭建数据对比模型分析推广问题，通过数据深度挖掘提供营销决策。',
                    // 图像位置（居左/居右）
                    pos: 'right'
                },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/data/advantage.js